import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/:rd/:pixel_id',
        name: 'main_list',
        component: () => import('@/views/main_web/main_index'),
    },
    {
        path: '/:rd/:pixel_id/info/:id',
        name: 'main_info',
        component: () => import('@/views/main_web/main_index'),
    },
    {
        path: '/sec/:rd/:pixel_id',
        name: 'sec_index',
        component: () => import('@/views/main_web/sec_index')
    },
    {
        path: '/sec-page/:rd/:pixel_id',
        name: 'sec_view',
        component: () => import('@/views/secView/secView')
    },
    {
        path: '/sec-next/:rd/:pixel_id',
        name: 'sec_next_view',
        component: () => import('@/views/secView/secNextView')
    },
    {
        path: '/thrList/:rd/:pixel_id',
        name: 'thr_list_view',
        component: () => import('@/views/secView/thrListView')
    },
    {
        path: '/thrInfo/:rd/:pixel_id/:id',
        name: 'thr_info_view',
        component: () => import('@/views/secView/thrInfoView')
    },
    {
        path: '/list/:rd/:pixel_id',
        name: 'comic_list',
        component: () => import('@/views/comic/comicList')
    },
    {
        path: '/info/:rd/:pixel_id/info/:id',
        name: 'comic_info',
        component: () => import('@/views/comic/comicInfo')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        beforeEnter: () => {
            window.location.href = '/main_web/main_index_new';
        }
    },
    {
        path: '/',
        name: 'main_root',
        component: () => import('@/views/main_web/main_index_new'),
    },
    {
        path: '/app-:appid/:rd/:pixel_id',
        name: 'main_list_new',
        component: () => import('@/views/main_web/main_index_new'),
    },
    {
        path: '/app-:appid/:rd/:pixel_id/info/:id',
        name: 'main_info_new',
        component: () => import('@/views/main_web/main_index_new'),
    },
    {
        path: '/app-:appid/list/:rd/:pixel_id',
        name: 'comic_list_new',
        component: () => import('@/views/comic/comicListNew')
    },
    {
        path: '/app-:appid/info/:rd/:pixel_id/info/:id',
        name: 'comic_info_new',
        component: () => import('@/views/comic/comicInfoNew')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes: routes
});

export default router;